import React, { useState } from 'react';
import { Table, Button, Input, InputGroup } from 'rsuite';
import { Search as SearchIcon } from '@material-ui/icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { translate } from 'react-i18next';
import './AdminTable.scss';
import { faClone, faEdit, faPlusCircle, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { CustomToolTip } from '../../../common/components/UI';
import { Paper } from '@material-ui/core';

const AdminTable = ({ handleCreateNewSetting, handleSearchFilter, handleEdit, handleDuplicate, handleDelete, options, ...props }) => {
    const { Column, HeaderCell, Cell } = Table;
    const { t } = props;
    const [sortColumn, setSortColumn] = useState();
    const [sortType, setSortType] = useState();

    const handleSortColumn = (column, type) => {
        const toggledSortingType = type === "desc" ? "asc" : "desc";
        setSortColumn(column);
        setSortType(toggledSortingType);
    }

    const data = () => {
        if (!sortColumn || !sortType) {
            return options;
        }

        const sortedOptions = options.sort((a, b) => a[sortColumn] < b[sortColumn] ? -1 : a[sortColumn] < b[sortColumn] ? 1 : 0)
        return sortType === "asc" ? sortedOptions : sortedOptions.reverse();
    }
    const TableButtons = ({ rowData }) => (
        <div className='table-buttons-container'>
            <div className="table-buttons">
                <CustomToolTip
                    enterDelay={500}
                    titletext={t('workPlanList.actions.edit')}
                    jsx={
                        <Button
                            className='table-button'
                            onClick={() => handleEdit(rowData)}
                        >
                            <FontAwesomeIcon className='icon fa-xl' icon={faEdit} />
                        </Button>
                    }
                />
                <CustomToolTip
                    enterDelay={500}
                    titletext={t('workPlanList.actions.duplicate')}
                    jsx={
                        <Button
                            className='table-button'
                            onClick={() => handleDuplicate(rowData)}
                        >
                            <FontAwesomeIcon className='icon fa-xl' icon={faClone} />
                        </Button>
                    }
                />
                <CustomToolTip
                    enterDelay={500}
                    titletext={t('workPlanList.actions.delete')}
                    jsx={
                        <span>
                            <Button
                                className='table-button'
                                onClick={() => handleDelete(rowData)}
                                disabled={rowData.isUsed}
                                style={{ pointerEvents: rowData.isUsed && 'none' }}
                            >
                                <FontAwesomeIcon className='icon fa-xl' icon={faTrash} style={{ color: rowData.isUsed && '#00000042' }} />
                            </Button>
                        </span>
                    }
                />
            </div>
        </div>
    );

    return (
        <>
            <div className='main-header'>
                <Button
                    onClick={handleCreateNewSetting}
                    color="primary"
                    className="main-header--button"
                >
                    <FontAwesomeIcon icon={faPlusCircle} />
                    {t('settings.newSetting')}
                </Button>
                <InputGroup className="main-header--search">
                    <Input placeholder={t('common.search')} onChange={handleSearchFilter} />
                    <InputGroup.Addon>
                        <SearchIcon />
                    </InputGroup.Addon>
                </InputGroup>
            </div>
            <Paper
                elevation={2}
                className='main-table-container'
            >
                <Table
                    data={data()}
                    autoHeight
                    className='main-table'
                    onSortColumn={handleSortColumn}
                    sortType={sortType}
                    sortcolumn={sortColumn}
                >
                    <Column sortable flexGrow={2} minWidth={200}>
                        <HeaderCell className='header-cell'>{t('settings.table.name')}</HeaderCell>

                            <Cell dataKey="name">
                                {(rowData) => (
                                    <div className='workPlanSetupList-table-name-cell'  onClick={() => handleEdit(rowData)}>
                                    <CustomToolTip
                                        enterDelay={250}
                                        titletext={rowData.name}
                                        jsx={<div>{rowData.name}</div>}
                                    />
                                    </div>)}
                            </Cell>
                        
                    </Column>
                    <Column sortable flexGrow={1.5} minWidth={150}>
                        <HeaderCell className='header-cell'>{t('settings.table.description')}</HeaderCell>
                        <Cell dataKey="description" />
                    </Column>
                    <Column sortable flexGrow={3} minWidth={250}>
                        <HeaderCell className='header-cell'>{t('settings.table.manageTemplate')}</HeaderCell>
                        <Cell dataKey="createTemplatesHyperfind" />
                    </Column>
                    <Column sortable flexGrow={3} minWidth={250}>
                        <HeaderCell className='header-cell'>{t('settings.table.manageShiftline')}</HeaderCell>
                        <Cell dataKey="manageShiftlinesHyperfind" />
                    </Column>
                    <Column sortable flexGrow={3} minWidth={280}>
                        <HeaderCell className='header-cell'>{t('settings.table.manageAssignment')}</HeaderCell>
                        <Cell dataKey="manageAssignmentsHyperfind" />
                    </Column>
                    <Column flexGrow={3} fixed='right' minWidth={300} >
                        <HeaderCell className='header-cell'></HeaderCell>
                        <Cell className='action-cell'>{rowData => <TableButtons rowData={rowData} />}</Cell>
                    </Column>
                </Table>
            </Paper>
        </>

    )
}

export default translate('workplanManager')(AdminTable);
